import { Alert, AvatarSize, AvatarStack, Chip, Image, Text, TextVariants } from "@next-platform/client-common-spicy-ui";
import { ICharacter, useTranslatedTag } from "@next-platform/client-common-core";
import React, { JSX } from "react";

import { Col, Row } from "@/components";
import { AvatarPreset } from "@/types";
import { cn, getAvatarUrl } from "@/utils";

import { ChatHeroCharacterDetailsProps, ChatHeroContainerProps } from "./types";

const ChatHeroContainer = ({
  chatHeroData = {} as ChatHeroCharacterDetailsProps,
  disclaimer = "",
  chatHeroAlertProps,
}: ChatHeroContainerProps): JSX.Element => {
  const { getTranslatedTag } = useTranslatedTag();
  const { src, name, tags = [], title, blurred, sub_characters } = chatHeroData;
  const { visible } = chatHeroAlertProps;
  return (
    <Col className="items-center gap-md max-mob:px-md">
      <Col className="py-md pt-lg px-lg max-mob:px-0 gap-sm items-center">
        <Col className="items-center gap-1">
          {sub_characters?.length ? (
            <AvatarStack
              avatarData={sub_characters.map((char: ICharacter) => {
                return {
                  url:
                    getAvatarUrl(char.avatar_url ?? "", {
                      preset: AvatarPreset.IMAGE_500X650,
                    }) ?? "",
                  alt: char.name ?? "",
                };
              })}
              avatarSize={AvatarSize.XLARGE}
            />
          ) : src ? (
            <Image src={src} alt={name || "Character avatar"} width={80} height={80} className={cn("rounded-lg", blurred && "blur-md")} />
          ) : null}
          {name && (
            <Text className="text-blue-12" variant={TextVariants.LABEL_LARGE_MEDIUM}>
              {name}
            </Text>
          )}
        </Col>

        {tags.length > 0 && (
          <Row className="gap-1 flex-wrap justify-center">
            {tags.map((tag, index) => (
              <Chip key={index} className="cursor-default">
                {getTranslatedTag(tag)}
              </Chip>
            ))}
          </Row>
        )}

        {title && (
          <Text className="text-gray-11" variant={TextVariants.LABEL_MEDIUM_REGULAR}>
            {title}
          </Text>
        )}
      </Col>

      {disclaimer && (
        <Text className="text-gray-12 py-md text-center" variant={TextVariants.LABEL_SMALL_REGULAR}>
          {disclaimer}
        </Text>
      )}

      {visible && <Alert isDismissable={false} {...chatHeroAlertProps} />}
    </Col>
  );
};

export default React.memo(ChatHeroContainer);
